import ApiService from "@/services/api.service"

export const DoctorService = {
  doctorsSchedule(doctor_id, branch_id) {
    return ApiService.get(`doctor/${doctor_id}/schedule?branch_id=${branch_id}`)
  },
  doctorsAvailabilityForDay(doctor_id, branch_id, day) {
    return ApiService.get(`doctor/${doctor_id}/schedule/${day}?branch_id=${branch_id}`)
  },
  saveDoctorScheduleDay(doctor_id, branch_id, params) {
    return ApiService.post(`doctor/${doctor_id}/schedule/day?branch_id=${branch_id}`, params)
  },
  deleteDoctorScheduleDay(doctor_id, branch_id, day_id) {
    return ApiService.delete(`doctor/${doctor_id}/schedule/day/${day_id}?branch_id=${branch_id}`)
  },
  deleteStaffWorkBlock(doctor_id, branch_id, work_id) {
    return ApiService.delete(`doctor/${doctor_id}/schedule/staff_work/${work_id}?branch_id=${branch_id}`)
  },
  monthAvailability(doctor_id, branch_id, month) {
    return ApiService.get(`doctor/${doctor_id}/schedule/month/${month}?branch_id=${branch_id}`, {}, { loader: false })
  },
  monthAvailabilityDetailed(doctor_id, branch_id, month) {
    return ApiService.get(`doctor/${doctor_id}/schedule/month/${month}/detailed?branch_id=${branch_id}`, {}, { loader: false })
  }

}
